import i18n from 'i18next';
import { get } from 'lodash';

import { None, sortBy } from 'components/data/helpers';
import type { AtlasGqlMaintenanceActivity } from 'types/atlas-graphql';
import { inlineEditable } from 'utils/editable/InlineEditable/InlineEditable';

import type { TDisplayColumnData, TEditColumnData } from '../../types';

import { MaintenanceActivityNameHeader, MaintenanceActivityStatusHeader } from './';

export const maintenanceActivityNameColumn = (): TDisplayColumnData => {
  return {
    key: 'name',
    title: i18n.t('table.name', 'Name'),
    dataIndex: 'maintenanceActivity',
    get: (record: any) => get(record, 'maintenanceActivity'),
    render: (maintenanceActivity: AtlasGqlMaintenanceActivity) => {
      const { name } = maintenanceActivity || {};

      return name?.length ? name : <None />;
    },
  };
};

export const maintenanceActivityIntervalColumn = (): TDisplayColumnData => {
  return {
    key: 'dayCount',
    title: i18n.t('task.interval', 'Interval'),
    dataIndex: 'maintenanceActivity',
    get: (record: any) => get(record, 'maintenanceActivity'),
    render: (maintenanceActivity: AtlasGqlMaintenanceActivity) => {
      const { dayCount } = maintenanceActivity || {};

      return dayCount ? i18n.t('task.intervalDays', '{{dayCount}} Days', { dayCount }) : <None />;
    },
  };
};

export const maintenanceActivityNameHeader = (): TEditColumnData => {
  const columnDef = inlineEditable({
    key: 'name',
    title: i18n.t('task.recurringTask', 'Recurring Task'),
    dataIndex: 'maintenanceActivity',
    get: (record: any) => get(record, 'maintenanceActivity'),
    render: (maintenanceActivity: AtlasGqlMaintenanceActivity) => {
      const { id } = maintenanceActivity || {};

      // If we don't have an id we probably have an error...
      if (!id) {
        return <None />;
      }

      return <MaintenanceActivityNameHeader maintenanceActivity={maintenanceActivity} />;
    },
  });

  return columnDef;
};

export const maintenanceActivityStatusHeader = () => {
  const columnDef = {
    title: i18n.t('task.recurrenceStatus', 'Recurrence Status'),
    key: 'maintenanceActivity',
    dataIndex: 'maintenanceActivity',
    sorter: sortBy('maintenanceActivity'),
    filterProperty: 'maintenanceActivity',
    get: (record: any) => get(record, 'maintenanceActivity'),
    render: (maintenanceActivity: AtlasGqlMaintenanceActivity) => {
      const { id } = maintenanceActivity || {};

      // If we don't have an id we probably have an error...
      if (!id) {
        return <None />;
      }

      return <MaintenanceActivityStatusHeader maintenanceActivity={maintenanceActivity} />;
    },
  };

  return columnDef;
};
